import { openTelegramLink } from "../utils/openLink";
import { Button } from "./Button";

export default function BannedAccountScreen() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen [background:linear-gradient(180deg,rgb(1,13,13)_0%,rgb(3.01,42.5,42.5)_100%)] bg-[100%_100%] bg-repeat-y bg-cover text-white p-4">
      <img
        src="/images/error-page.png"
        alt="account-banned"
        className="w-full max-w-[343px] h-full max-h-[343px] mb-[21px]"
      />
      <h2 className="text-2xl font-bold mb-2.5 text-center">Ваш аккаунт заблокирован</h2>
      <p className="text-gray-400 mb-3 text-center">
        Доступ к приложению ограничен администратором. Если вы считаете, что это произошло по ошибке, обратитесь в
        поддержку.
      </p>
      <div className="mb-[24px]" />
      <Button className="w-full max-w-[343px]" onClick={() => openTelegramLink('https://t.me/myta_support')}>
        Написать в поддержку
      </Button>
    </div>
  );
}
